'use client';

import React, { Suspense, useState } from 'react';
import { useRouter, useSearchParams } from 'next/navigation';

function LoginForm() {
  const router = useRouter();
  const sp = useSearchParams();
  const next = sp?.get('next') || '/';
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function onSubmit(e: React.FormEvent) {
    e.preventDefault();
    setError(null);
    setBusy(true);
    try {
      const res = await fetch('/api/login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username, password }),
      });
      if (res.ok) {
        router.push(next);
        router.refresh();
      } else if (res.status === 401) {
        setError('Неверный логин или пароль');
      } else {
        setError(`Ошибка: ${res.status}`);
      }
    } catch {
      setError('Сеть недоступна');
    } finally {
      setBusy(false);
    }
  }

  return (
    <form
      onSubmit={onSubmit}
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: '0.75rem',
        minWidth: 320,
        maxWidth: 400,
        width: '100%',
      }}
    >
      <h2 style={{ margin: 0, marginBottom: '0.5rem' }}>Вход по учётной записи</h2>
      <input
        type="text"
        placeholder="Логин"
        value={username}
        onChange={(e) => setUsername(e.target.value)}
        required
        autoFocus
        autoComplete="username"
      />
      <input
        type="password"
        placeholder="Пароль"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        required
        autoComplete="current-password"
      />
      {error && <div style={{ color: '#f55', fontSize: 14 }}>{error}</div>}
      <button className="lk-button" type="submit" disabled={busy}>
        {busy ? 'Вход…' : 'Войти'}
      </button>
      <div style={{ fontSize: 12, opacity: 0.7, marginTop: '0.5rem' }}>
        Гости подключаются по прямой ссылке, без логина.
      </div>
    </form>
  );
}

export default function LoginPage() {
  return (
    <main className="lk-login-page"
      data-lk-theme="default"
      style={{ display: 'grid', placeItems: 'center', minHeight: '100vh', padding: '1rem' }}
    >
      <Suspense fallback={<div>Загрузка…</div>}>
        <LoginForm />
      </Suspense>
    </main>
  );
}
